import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Switch from 'react-ios-switch';
import { Helmet } from 'react-helmet';
import { MdStar, MdStarBorder } from 'react-icons/md';

import PanelMenu from './PanelMenu';
import AdministrationPage from '../containers/AdministrationPage';

class AdminBoardgamesListPage extends Component {
  constructor(props) {
    super(props);

    this.handleSelectionClick = this.handleSelectionClick.bind(this);
    this.handleVisibilityClick = this.handleVisibilityClick.bind(this);
    this.onChangeQuery = this.onChangeQuery.bind(this);
    this.onClearQueryClick = this.onClearQueryClick.bind(this);

    this.state = {
      q: '',
    };
  }

  componentDidMount() {
    this.props.getAllBoardgames();
  }

  handleSelectionClick(bg, selection) {
    return () => {
      this.props.markBoardgameAsSelection(bg, selection);
    };
  }

  handleVisibilityClick(bg) {
    return (visible) => {
      this.props.setBoardgameVisibility(bg, visible);
    };
  }

  onChangeQuery(event) {
    event.preventDefault();
    event.persist();
    this.setState({ q: event.target.value || '' });
  }

  onClearQueryClick() {
    this.setState({ q: '' });
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Amministrazione - Smart Gaming</title>
        </Helmet>
        <AdministrationPage>
          <div className="w-full max-w-lg relative">
            <h1 className="font-black font-serif mb-8 text-3xl tracking-tight block text-black">Tutti i giochi</h1>
          </div>
          <div className="w-full mx-auto">
            <div className="bg-white shadow-md rounded my-6">
              <table className="text-left w-full border-collapse">
                <thead>
                  <tr>
                    <th colSpan="3" className="w-16 py-4 px-6 bg-gray-100 font-bold text-sm text-gray-500 border-b border-gray-300">
                      <div className="flex relative">
                        <Link to="/admin/boardgames/create" className="absolute h-full flex justify-center items-center cursor-pointer bg-blue-700 hover:bg-blue-900 text-white py-2 px-4 top-0 left-0 rounded rounded-r-none">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="#FFFFFF" d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z"/></svg>
                        </Link>
                        <input
                          className="bg-gray-200 appearance-none border-2 border-gray-200 rounded rounded-l-none w-full py-2 px-4 pl-16 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-blue-500"
                          id="q"
                          type="text"
                          placeholder="Cerca"
                          value={this.state.q}
                          onChange={this.onChangeQuery} />
                          <button type="button" onClick={this.onClearQueryClick} className="absolute inset-y-0 right-0 flex items-center px-4 cursor-pointer text-gray-700">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                              <path fill="#4a5568" d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/>
                            </svg>
                          </button>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.props.boardgames
                      .filter(bg => bg.title.toLocaleLowerCase().includes(this.state.q.trim().toLocaleLowerCase()))
                      .sort((a, b) => {
                        if (a.title.toLocaleLowerCase() > b.title.toLocaleLowerCase()) {
                          return 1;
                        }

                        if (a.title.toLocaleLowerCase() < b.title.toLocaleLowerCase()) {
                          return -1;
                        }

                        return 0;
                      })
                      .map(boardgame => {
                        return (
                          <tr key={boardgame.id} className="hover:bg-gray-200">
                            <td className="w-4/5 md:w-11/12 p-4 border-b border-gray-300">
                              <Link className={`${!!!boardgame.visible ? 'opacity-50' : ''}`} to={`/admin/boardgames/${boardgame.id}`}>
                                <span className="font-bold truncate w-full">
                                  {
                                    !!boardgame.selection
                                      ? <MdStar size="1.3rem" className="text-yellow-500 inline-block mr-2" />
                                      : <MdStarBorder size="1.3rem" className="text-yellow-500 inline-block mr-2" />
                                  }
                                  { boardgame.title }
                                </span>
                              </Link>
                            </td>
                            <td className="w-1/5 md:w-1/12 text-center p-4 border-b border-gray-300">
                              <div className="flex justify-end">
                                <PanelMenu>
                                  <ul>
                                    <li className="px-4 py-3 pb-5 flex justify-between border-b border-gray-300">
                                      <span className="mr-8">SG&nbsp;Selection</span>
                                      <Switch checked={!!boardgame.selection} disabled={!boardgame.visible} onChange={this.handleSelectionClick(boardgame, !!!boardgame.selection)} />
                                    </li>
                                    <li className="px-4 py-3 pt-5 flex justify-between">
                                      <span className="mr-8">Visibile</span>
                                      <Switch checked={!!boardgame.visible} onChange={this.handleVisibilityClick(boardgame)} />
                                    </li>
                                  </ul>
                                </PanelMenu>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                  }
                </tbody>
              </table>
            </div>
          </div>
        </AdministrationPage>
      </React.Fragment>
    );
  }
}

export default AdminBoardgamesListPage;
